import { lazy } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";

const PageNotFound = lazy(() => import("../pages/PageNotFound"));
const DashboardLayout = lazy(() => import("../layouts/DashboardLayout"));
const RouteGuard = lazy(() => import("../guards/RouteGuard"));
const BusinessReviews = lazy(() => import("../pages/business/reviews/BusinessReviews"));
const BusinessOffers = lazy(() => import("../pages/business/offers/BusinessOffers"));
const BusinessSettings = lazy(() => import("../pages/business/settings/BusinessSettings"));
const Businesses = lazy(() => import("../pages/business/businesses/Businesses"));
const Shop = lazy(() => import("../pages/shop/Shop"));
const BusinessProfileSetup = lazy(
  () => import("../pages/businessProfileSetup/BusinessProfileSetup"),
);
const SignIn = lazy(() => import("../pages/auth/SignIn"));
const SplitLayout = lazy(() => import("../components/SplitLayout"));
const SignUp = lazy(() => import("../pages/auth/SignUp"));
const ForgotPassword = lazy(() => import("../pages/auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/auth/ResetPassword"));
const VerifyOtp = lazy(() => import("../pages/auth/VerifyOtp"));
const AuthSuccess = lazy(() => import("../pages/auth/AuthSuccess"));
const SubscriptionCheckoutSuccess = lazy(
  () => import("../pages/SubscriptionCheckoutSuccess"),
);
const SubscriptionCheckoutCancel = lazy(
  () => import("../pages/SubscriptionCheckoutCancel"),
);

const routes = createBrowserRouter([
  {
    path: "/",
    element: <RouteGuard />,
    children: [
      {
        path: "subscription/success",
        element: <SubscriptionCheckoutSuccess />,
      },
      {
        path: "subscription/cancel",
        element: <SubscriptionCheckoutCancel />,
      },
      {
        path: "/",
        element: <DashboardLayout />,
        children: [
          {
            path: "",
            element: <Navigate to="/businesses" />,
          },
          {
            path: "businesses",
            element: <Businesses />,
          },

          {
            path: "business/:id/update",
            element: <BusinessProfileSetup />,
          },
          {
            path: "profile",
            element: <BusinessProfileSetup />,
          },
          {
            path: "reviews",
            element: <BusinessReviews />,
          },
          {
            path: "offers",
            element: <BusinessOffers />,
          },
          {
            path: "settings",
            element: <BusinessSettings />,
          },
          {
            path: "shop",
            element: <Shop />,
          },
        ],
      },
    ],
  },

  {
    path: "/auth",
    element: <SplitLayout />,
    children: [
      {
        path: "sign-in",
        element: <SignIn />,
      },
      { path: "sign-up", element: <SignUp /> },
      { path: "forgot-password", element: <ForgotPassword /> },
      { path: "verify-otp", element: <VerifyOtp /> },
      { path: "reset-password", element: <ResetPassword /> },
      { path: "success", element: <AuthSuccess /> },
    ],
  },

  { path: "*", element: <PageNotFound /> },
]);

export default routes;
